import { StatisticActionTypes } from '@/constants'
import { globalState } from '@/store'
import reportAction from '@/utils/statistic'
import { useCallback, useEffect, useState } from 'react'

export default function usePageStayTime() {
  const [stayStartTime, setStayStartTime] = useState(performance.now()) // 初始化开始时间
  const [stayEndTime, setStayEndTime] = useState(0)
  const [userActive, setUserActive] = useState(false)
  useEffect(() => {
    // 更新用户活动状态
    const updateUserActivity = () => {
      setUserActive(true)
    }
    // 监听鼠标移动和键盘按键事件
    document.addEventListener('mousemove', updateUserActivity)
    document.addEventListener('keydown', updateUserActivity)
    return () => {
      document.removeEventListener('mousemove', updateUserActivity)
      document.removeEventListener('keydown', updateUserActivity)
    }
  }, [])

  // 监听应用激活状态变化，记录开始时间和停留时间
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // 应用变为可见状态，记录开始停留时间
        setStayStartTime(performance.now())
        // setUserActive(true)
      } else if (document.visibilityState === 'hidden' && stayStartTime !== 0) {
        // 应用变为不可见状态，记录结束停留时间，并触发上报
        setStayEndTime(performance.now())
        // setUserActive(false)
      }
    }
    // 监听应用激活状态变化
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [stayStartTime])

  // 4. 在停留结束时，上报停留时长数据到服务器
  useEffect(() => {
    if (stayEndTime > stayStartTime && userActive) {
      const stayDuration = stayEndTime - stayStartTime
      globalState.userInfo.id &&
        reportAction(
          { action: StatisticActionTypes.WEB_RUNNING_DUR },
          { boot_duration: stayDuration },
        )
    }
  }, [stayEndTime, stayStartTime, userActive])

  // 页面导航时重置停留时长统计
  useEffect(() => {
    const handleNavigation = () => {
      if (stayStartTime !== 0 && stayEndTime === 0 && userActive) {
        setStayEndTime(performance.now())
        globalState.userInfo.id &&
          reportAction(
            { action: StatisticActionTypes.WEB_RUNNING_DUR },
            { boot_duration: performance.now() - stayStartTime },
          )
      }
      // 重置统计数据
      setStayStartTime(0)
      setStayEndTime(0)
      setUserActive(false)
    }

    window.addEventListener('beforeunload', handleNavigation)
    return () => {
      console.log('beforeunload 事件监听器已被移除')
      window.removeEventListener('beforeunload', handleNavigation)
    }
  }, [stayStartTime, stayEndTime, userActive])

  // 心跳上报，每隔1分钟调用一次接口
  useEffect(() => {
    globalState.userInfo.id &&
      userActive &&
      reportAction({ action: StatisticActionTypes.WEB_RUNNING_TIME })
    const heartbeatInterval = setInterval(() => {
      globalState.userInfo.id &&
        userActive &&
        reportAction({ action: StatisticActionTypes.WEB_RUNNING_TIME })
    }, 60000) // 每60秒上报一次
    return () => {
      clearInterval(heartbeatInterval)
      console.log('心跳上报定时器已被清除')
    }
  }, [userActive])
  return null
}
